"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleApp = void 0;
const Config_1 = require("../../app/Config");
const FaceTecSDK_1 = require("./../../core-sdk/FaceTecSDK.js/FaceTecSDK");
const LivenessCheckProcessor_1 = require("./processors/LivenessCheckProcessor");
const EnrollmentProcessor_1 = require("./processors/EnrollmentProcessor");
const AuthenticateProcessor_1 = require("./processors/AuthenticateProcessor");
const SampleAppUtilities_1 = require("./utilities/SampleAppUtilities");
const PhotoIDMatchProcessor_1 = require("./processors/PhotoIDMatchProcessor");
const PhotoIDScanProcessor_1 = require("./processors/PhotoIDScanProcessor");
const ThemeHelpers_1 = require("./utilities/ThemeHelpers");
const AdditionalScreens_1 = require("./utilities/AdditionalScreens");
const DeveloperStatusMessages_1 = require("./utilities/DeveloperStatusMessages");
const universal_cookie_1 = __importDefault(require("universal-cookie"));
const sign_document_1 = require("../../app/api/calls/document/sign_document");
function authenticateAndSignDocument(facetecDBRef, document_id, onSuccess) {
    exports.SampleApp.onAuthenticateUserPressed(facetecDBRef, (success) => __awaiter(this, void 0, void 0, function* () {
        if (success) {
            try {
                yield (0, sign_document_1.sign_document)({ document_id });
                if (onSuccess)
                    onSuccess(true);
            }
            catch (err) {
                if (onSuccess)
                    onSuccess(false);
                console.error("Error in sign_document:", err);
            }
        }
        else {
            if (onSuccess)
                onSuccess(false);
        }
    }));
}
exports.SampleApp = (() => {
    var latestEnrollmentIdentifier = "";
    var latestProcessor;
    var latestSessionResult = null;
    var latestIDScanResult = null;
    // Wait for onload to be complete before attempting to access the Browser SDK.
    window.onload = () => {
        SampleAppUtilities_1.SampleAppUtilities.formatUIForDevice();
        // Set a the directory path for other FaceTec Browser SDK Resources.
        //  FaceTecSDK.setResourceDirectory("./../../core-sdk/FaceTecSDK.js/resources");
        FaceTecSDK_1.FaceTecSDK.setResourceDirectory("facetec/resources");
        // Set the directory path for required FaceTec Browser SDK images.
        //FaceTecSDK.setImagesDirectory("./../../core-sdk/FaceTec_images");
        FaceTecSDK_1.FaceTecSDK.setImagesDirectory("facetec/images");
        console.log("FaceTecApp -> window.onload");
        console.log("FaceTecApp -> window.onload -> Config.didSucceed", Config_1.Config.didSucceed);
        console.log("FaceTecApp -> window.onload -> Config", Config_1.Config.ProductionKeyText, "and", Config_1.Config.DeviceKeyIdentifier);
        /**@TODO @Desmond Fix context switch error when the weeb-app tries to redirect automatically */
        SampleAppUtilities_1.SampleAppUtilities.fadeInMainUIContainer();
    };
    // Clear previous session results;
    function initializeResultObjects() {
        latestSessionResult = null;
        latestIDScanResult = null;
    }
    // Initiate a 3D Liveness Check.
    function onLivenessCheckPressed() {
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.
        getSessionToken((sessionToken) => {
            latestProcessor = new LivenessCheckProcessor_1.LivenessCheckProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Initiate a 3D Liveness Check, then storing the 3D FaceMap in the Database, also known as "Enrollment".  A random enrollmentIdentifier is generated each time to guarantee uniqueness.
    function onEnrollUserPressed() {
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the Enrollment.
        getSessionToken((sessionToken) => {
            latestEnrollmentIdentifier = "skysign_browser_app_" + SampleAppUtilities_1.SampleAppUtilities.generateUUId();
            latestProcessor = new EnrollmentProcessor_1.EnrollmentProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Perform 3D to 3D Authentication against the Enrollment previously performed.
    function onAuthenticateUserPressed(facetecDBRef) {
        initializeResultObjects();
        // Set the enrollment identifier from the parameter (user's facetecDBRef)
        if (facetecDBRef) {
            latestEnrollmentIdentifier = facetecDBRef;
        }
        // For demonstration purposes, verify that we have an enrollmentIdentifier to Authenticate against.
        if (latestEnrollmentIdentifier.length === 0) {
            DeveloperStatusMessages_1.DeveloperStatusMessages.logAndDisplayMessage("Please enroll first before trying authentication.");
        }
        else {
            SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
            // Get a Session Token from the FaceTec SDK, then start the 3D to 3D Matching.
            getSessionToken((sessionToken) => {
                latestProcessor = new AuthenticateProcessor_1.AuthenticateProcessor(sessionToken, exports.SampleApp);
            });
        }
    }
    // Perform a 3D Liveness Check, then an ID Scan, then Match the 3D FaceMap to the ID Scan.
    function onPhotoIDMatchPressed() {
        var _a;
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        const cookie = new universal_cookie_1.default();
        let userData = cookie.get("user_state");
        latestEnrollmentIdentifier = (_a = userData === null || userData === void 0 ? void 0 : userData.facetecDBRef) !== null && _a !== void 0 ? _a : "";
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.  On Success, ID Scanning will start automatically.
        getSessionToken((sessionToken) => {
            //latestEnrollmentIdentifier = "skylifestyle_browser_app_" + SampleAppUtilities.generateUUId();
            latestProcessor = new PhotoIDMatchProcessor_1.PhotoIDMatchProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Perform Photo ID Scan, generating a username each time to guarantee uniqueness.
    function onPhotoIDScanPressed() {
        initializeResultObjects();
        SampleAppUtilities_1.SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.  On Success, ID Scanning will start automatically.
        getSessionToken(function (sessionToken) {
            latestProcessor = new PhotoIDScanProcessor_1.PhotoIDScanProcessor(sessionToken, exports.SampleApp);
        });
    }
    // Show the final result with the Session Review Screen.
    var onComplete;
    onComplete = (sessionResult, idScanResult, latestNetworkResponseStatus) => {
        latestSessionResult = sessionResult;
        latestIDScanResult = idScanResult;
        if (latestProcessor.isSuccess()) {
            // Display message to user, Success messages are already logged from the processors.
            DeveloperStatusMessages_1.DeveloperStatusMessages.displayMessage("See logs for details");
        }
        else {
            // Log result for unSuccess Sessions.
            DeveloperStatusMessages_1.DeveloperStatusMessages.logScanOncompleteResult(sessionResult, idScanResult);
            // Check for server offline
            if (isNetworkResponseServerIsOffline(latestNetworkResponseStatus) === true) {
                showAdditionalScreensServerIsDown();
                return;
            }
        }
        SampleAppUtilities_1.SampleAppUtilities.showMainUI();
    };
    // Check for server down status
    function isNetworkResponseServerIsOffline(networkResponseStatus) {
        return networkResponseStatus >= 500;
    }
    // Set a new customization for FaceTec Browser SDK.
    function onDesignShowcasePressed() {
        ThemeHelpers_1.ThemeHelpers.showNewTheme();
    }
    function onVocalGuidanceSettingsButtonPressed() {
        SampleAppUtilities_1.SampleAppUtilities.setVocalGuidanceMode();
    }
    // Display audit trail images captured from user's last FaceTec Browser SDK Session (if available).
    function onViewAuditTrailPressed() {
        SampleAppUtilities_1.SampleAppUtilities.showAuditTrailImages(latestSessionResult, latestIDScanResult);
    }
    let sessionTokenErrorHasBeenHandled = false;
    function onSessionTokenError(xhrStatus) {
        if (sessionTokenErrorHasBeenHandled === false) {
            sessionTokenErrorHasBeenHandled = true;
            if (xhrStatus !== undefined && isNetworkResponseServerIsOffline(xhrStatus)) {
                showAdditionalScreensServerIsDown();
            }
            else {
                onServerSessionTokenError();
            }
        }
    }
    // Get the Session Token from the server
    function getSessionToken(sessionTokenCallback) {
        sessionTokenErrorHasBeenHandled = false;
        //TODO - Add .content
        try {
            var XHR = new XMLHttpRequest();
            XHR.open("GET", Config_1.Config.BaseURL + "/session-token");
            XHR.setRequestHeader("X-Device-Key", Config_1.Config.DeviceKeyIdentifier);
            XHR.setRequestHeader("X-User-Agent", FaceTecSDK_1.FaceTecSDK.createFaceTecAPIUserAgentString(""));
            XHR.onreadystatechange = function () {
                if (this.readyState === XMLHttpRequest.DONE) {
                    var sessionToken = "";
                    try {
                        // Attempt to get the sessionToken from the response object.
                        sessionToken = JSON.parse(this.responseText).content.sessionToken;
                        // Something went wrong in parsing the response. Return an error.
                        if (typeof sessionToken !== "string") {
                            onSessionTokenError(XHR.status);
                            return;
                        }
                    }
                    catch (_a) {
                        // Something went wrong in parsing the response. Return an error.
                        XHR.abort();
                        onSessionTokenError(XHR.status);
                        return;
                    }
                    SampleAppUtilities_1.SampleAppUtilities.hideLoadingSessionToken();
                    sessionTokenCallback(sessionToken);
                }
            };
            // Wait 3s, if the request is not completed yet, show the session token loading screen
            window.setTimeout(() => {
                if (XHR.readyState !== XMLHttpRequest.DONE) {
                    if (sessionTokenErrorHasBeenHandled === false) {
                        SampleAppUtilities_1.SampleAppUtilities.showLoadingSessionToken();
                    }
                }
            }, 3000);
            XHR.onerror = function () {
                XHR.abort();
                onSessionTokenError(XHR.status);
            };
            XHR.send();
        }
        catch (e) {
            onSessionTokenError(undefined);
        }
    }
    function showAdditionalScreensServerIsDown() {
        AdditionalScreens_1.AdditionalScreens.showServerUpGradeView();
    }
    function onServerSessionTokenError() {
        SampleAppUtilities_1.SampleAppUtilities.handleErrorGettingServerSessionToken();
    }
    var getLatestEnrollmentIdentifier = () => {
        return latestEnrollmentIdentifier;
    };
    var clearLatestEnrollmentIdentifier = () => {
        latestEnrollmentIdentifier = "";
    };
    function exitAdditionalScreen() {
        AdditionalScreens_1.AdditionalScreens.exitAdditionalScreen(SampleAppUtilities_1.SampleAppUtilities.showMainUI);
    }
    return {
        onLivenessCheckPressed,
        onEnrollUserPressed,
        onAuthenticateUserPressed,
        onPhotoIDMatchPressed,
        onPhotoIDScanPressed,
        onDesignShowcasePressed,
        onComplete,
        getLatestEnrollmentIdentifier,
        clearLatestEnrollmentIdentifier,
        onVocalGuidanceSettingsButtonPressed,
        onViewAuditTrailPressed,
        authenticateAndSignDocument,
        latestSessionResult,
        latestIDScanResult,
    };
})();
